import designSystemStyles from "@shared/styles/designSystemStyles"
import { Text } from "@shared/designSystem/Texts"

interface RadioButtonProps {
    text?: string
    selected: boolean
    onClick: () => void
    disabled?: boolean
    className?: string
    tabIndex?: number
}

export const RadioButton: React.FC<RadioButtonProps> = ({
    text,
    selected,
    onClick,
    disabled = false,
    className,
    tabIndex
}) => {
    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (disabled) {
            return
        }
        if (event.key === " " || event.key === "Enter") {
            event.preventDefault()
            onClick()
        }
    }

    return (
        <div
            className={["DSRadioButton", className].filter(Boolean).join(" ")}
            role="radio"
            aria-checked={selected}
            tabIndex={tabIndex ?? (disabled ? -1 : 0)}
            onClick={disabled ? () => {} : onClick}
            onKeyDown={handleKeyDown}
            style={{
                display: "inline-flex",
                flexDirection: "row",
                alignItems: "center",
                gap: designSystemStyles.gapSm,
                cursor: disabled ? "not-allowed" : "pointer",
                opacity: disabled ? 0.7 : 1,
                userSelect: "none"
            }}
        >
            <div
                style={{
                    width: "16px",
                    height: "16px",
                    borderRadius: "50%",
                    border: `1px solid ${selected ? designSystemStyles.colorMainAction : designSystemStyles.colorTextInputBorder}`,
                    backgroundColor: "transparent",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "0.15s ease"
                }}
            >
                {selected && (
                    <div
                        style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            backgroundColor: designSystemStyles.colorMainAction
                        }}
                    />
                )}
            </div>
            {text && <Text text={text} color={designSystemStyles.colorText} />}
        </div>
    )
}
